import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'y42-ref-integrity-test',
  templateUrl: './ref-integrity-test.component.html',
  styleUrls: ['./ref-integrity-test.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefIntegrityTestComponent {
  constructor() {
    // need to import dependencies
  }
}
